import { useMemo } from 'react';

import { OpportunityView } from '@ndvr/customer-api';

import { OpportunityViewState } from './opportunity-state';

interface UseFilteredOpportunitiesProps {
    opportunities: OpportunityView[];
    filters: OpportunityViewState;
}

export const useFilteredOpportunities = ({ opportunities, filters }: UseFilteredOpportunitiesProps) => {
    return useMemo(() => {
        return opportunities.filter((opportunity) => {
            // Filter by status
            if (filters.selectedStatuses.length > 0 && !filters.selectedStatuses.includes(opportunity.status)) {
                return false;
            }

            // Filter by household
            if (
                filters.selectedHouseholds.length > 0 &&
                !filters.selectedHouseholds.includes(opportunity.householdGUID)
            ) {
                return false;
            }

            // Filter by minimum value
            if (filters.minimumValue !== null) {
                const opportunityValue = Number(opportunity.value) || 0;
                if (opportunityValue < filters.minimumValue) {
                    return false;
                }
            }

            return true;
        });
    }, [opportunities, filters]);
};
